import { Icon } from "./icons"
import { Box } from "@mui/material"
import React from "react"

// decorative glyph inside the link it decorates — aria-hidden keeps it out
// of the accessibility tree (the link's text already names the target)
const iconSx = {
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "-0.09em",
    ml: 0.4,
    // keep the icon from gluing to the punctuation that follows the anchor
    // ("~70%↗;" read as one cluster)
    mr: "2px",
    color: "text.primary",
    opacity: 0.5,
}

export const LinkIcon: React.FC = () => {
    return (
        <Box component="span" sx={iconSx}>
            <Icon name="externalLink" style={{ fontSize: "0.85em" }} />
        </Box>
    )
}
